export function limiter(concurrency: number) {
    let activeCount = 0;
    const queue: LimiterQueue[] = [];

    const next = () => {
        if (activeCount >= concurrency || queue.length === 0) return;

        activeCount++;

        //@ts-ignore // тут всегда будет хотя бы одна queue
        const { task, resolve, reject } = queue.shift();

        task()
            .then(resolve)
            .catch(reject)
            .finally(() => {
                activeCount--;
                next();
            });
    };

    return (task: LimiterQueue["task"]) => {
        return new Promise((resolve, reject) => {
            queue.push({ task, resolve, reject });
            next();
        });
    };
}

type LimiterQueue = {
    task: () => Promise<unknown>;
    resolve: (value: unknown) => void;
    reject: () => void;
};
